export class SkuPostModel {
    id: string;
    number: string;
    shortName: string;
    name1: string;
    description: string;
    catalogNetPrice?: number;
    catalogGrossPrice?: number;
    // Backend #633 A: the 0..n category tag set — empty is valid (min-0, a deliberately
    // uncategorized listing).
    productCategoryIds: string[] = [];
    vatId: string;
    availableQuantity: number;
    isActive: boolean;
    gtin: string;
    msrpNetPrice: number;
    hasSerial: boolean;
    filesToDelete?: string[];
}
